export const IllustNoSearch = ({ width = '100%' }: JSX.IntrinsicElements['svg']) => (
  <svg width='140' height='140' viewBox='0 0 140 140' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clip-path='url(#clip0_12013_26018)'>
      <path
        d='M43.5452 91.6515L56.9358 47.6804L66.4392 50.5974C70.2163 51.7567 70.2791 62.5535 66.5819 74.6834C62.8848 86.8132 56.8249 95.7308 53.0477 94.5714L43.5452 91.6515Z'
        fill='url(#paint0_linear_12013_26018)'
      />
      <path
        d='M78.7366 66.3883L132.748 82.966C136.388 84.0833 137.823 89.8939 135.984 95.9643C134.146 102.035 129.7 106.044 126.069 104.919L72.0457 88.338C75.6888 89.4562 80.1261 85.4416 81.9721 79.3798C83.8181 73.318 82.3797 67.5065 78.7366 66.3883Z'
        fill='#999999'
      />
      <path
        d='M78.7366 66.3883L132.748 82.966C136.388 84.0833 137.823 89.8939 135.984 95.9643C134.146 102.035 129.7 106.044 126.069 104.919L72.0457 88.338C75.6888 89.4562 80.1261 85.4416 81.9721 79.3798C83.8181 73.318 82.3797 67.5065 78.7366 66.3883Z'
        fill='url(#paint1_linear_12013_26018)'
      />
      <path
        d='M65.4642 50.2973L69.885 51.6544C72.7179 52.524 87.3469 61.8234 81.9928 79.4075C76.6387 96.9916 59.3307 96.4902 56.4999 95.6245L52.0644 94.2628'
        fill='#999999'
      />
      <path
        d='M65.4642 50.2973L69.885 51.6544C72.7179 52.524 87.3469 61.8234 81.9928 79.4075C76.6387 96.9916 59.3307 96.4902 56.4999 95.6245L52.0644 94.2628'
        fill='url(#paint2_linear_12013_26018)'
      />
      <path
        d='M43.5452 91.6515L56.9358 47.6804L66.4392 50.5974C70.2163 51.7567 70.2791 62.5535 66.5819 74.6834C62.8848 86.8132 56.8249 95.7308 53.0477 94.5714L43.5452 91.6515Z'
        fill='#CCCCCC'
      />
      <path
        d='M43.5507 91.6581C47.328 92.8174 53.3878 83.9141 57.0858 71.7721C60.7837 59.63 60.7194 48.8472 56.9422 47.6879C53.1649 46.5286 47.105 55.4319 43.407 67.574C39.7091 79.716 39.7734 90.4988 43.5507 91.6581Z'
        fill='url(#paint3_linear_12013_26018)'
      />
      <path
        d='M46.8222 68.6252C49.7819 58.9076 54.8649 51.8625 58.1634 52.8748C58.5155 53 58.8392 53.1942 59.1157 53.4458C59.3923 53.6975 59.6162 54.0017 59.7743 54.3408C59.8384 60.2577 58.93 66.1434 57.0854 71.762C55.4842 77.4564 52.9583 82.8467 49.6089 87.7172C49.2887 87.9089 48.9336 88.035 48.5642 88.0884C48.1949 88.1418 47.8185 88.1214 47.4568 88.0284C44.1558 87.0347 43.8694 78.3417 46.8222 68.6252Z'
        fill='url(#paint4_radial_12013_26018)'
      />
      <path
        d='M51.953 70.1927C53.339 65.6409 56.7567 62.6583 59.5908 63.5251C62.425 64.3918 57.4008 80.8803 54.5733 80.0027C51.7457 79.125 50.5631 74.7465 51.953 70.1927Z'
        fill='#CCCCCC'
      />
      <path
        d='M59.4552 51.7005C60.3481 56.1298 59.5516 63.652 57.0843 71.7627C54.6169 79.8734 51.0817 86.5617 47.8716 89.7287C46.6778 91.1729 45.0574 91.8935 43.546 91.6402L46.9694 92.6907C50.7478 93.8501 56.8158 84.9334 60.5083 72.8005C64.2008 60.6675 64.146 49.8752 60.3655 48.7119L56.9451 47.6623C58.3329 48.3213 59.2749 49.8282 59.4552 51.7005Z'
        fill='#999999'
      />
      <path
        d='M59.4552 51.7005C60.3481 56.1298 59.5516 63.652 57.0843 71.7627C54.6169 79.8734 51.0817 86.5617 47.8716 89.7287C46.6778 91.1729 45.0574 91.8935 43.546 91.6402L46.9694 92.6907C50.7478 93.8501 56.8158 84.9334 60.5083 72.8005C64.2008 60.6675 64.146 49.8752 60.3655 48.7119L56.9451 47.6623C58.3329 48.3213 59.2749 49.8282 59.4552 51.7005Z'
        fill='url(#paint5_linear_12013_26018)'
      />
      <path
        d='M43.173 88.1336C42.059 85.217 42.2071 77.7101 45.1342 68.0992C48.8136 56.0182 54.1996 49.2411 56.2911 49.883C56.5514 50.0159 56.7801 50.2034 56.9614 50.4329C57.1428 50.6625 57.2725 50.9284 57.3417 51.2127C58.4557 54.1293 58.3224 61.6407 55.3894 71.2498C53.9574 76.2499 51.813 81.0161 49.0222 85.4012C47.1343 88.1802 45.2499 89.7685 44.2275 89.4612C43.9672 89.3289 43.7387 89.1416 43.5577 88.9122C43.3768 88.6827 43.2479 88.4166 43.1798 88.1324M41.4963 89.316C41.6389 89.838 41.8989 90.3205 42.2563 90.7266C42.6137 91.1327 43.059 91.4516 43.5582 91.6588C47.3358 92.8182 53.3959 83.913 57.0942 71.7698C59.9139 62.5114 60.551 54.0469 59.0199 50.0145C58.8771 49.4927 58.6171 49.0102 58.2597 48.6042C57.9023 48.1981 57.4571 47.8792 56.9581 47.6717C53.1804 46.5124 47.1213 55.4146 43.42 67.5569C40.5994 76.8183 39.9632 85.2798 41.4972 89.313L41.4963 89.316Z'
        fill='#DDDDDD'
      />
      <path
        d='M56.7005 52.4511L8.4209 15.4094L-14.6507 91.1886L46.0012 87.593C46.0012 87.593 51.7114 83.3695 55.3974 71.2627C59.0834 59.156 56.7005 52.4511 56.7005 52.4511Z'
        fill='url(#paint6_linear_12013_26018)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_12013_26018'
        x1='51.7176'
        y1='94.1599'
        x2='65.2048'
        y2='50.2185'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#999999' />
        <stop offset='0.49' stop-color='#999999' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_12013_26018'
        x1='97.702'
        y1='106.22'
        x2='115.555'
        y2='60.382'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#999999' />
        <stop offset='0.49' stop-color='#999999' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_12013_26018'
        x1='63.6894'
        y1='97.8283'
        x2='77.1767'
        y2='53.8928'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#999999' />
        <stop offset='0.49' stop-color='#999999' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_12013_26018'
        x1='56.946'
        y1='47.6859'
        x2='43.4592'
        y2='91.63'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.04' stop-color='#999999' />
        <stop offset='0.49' stop-color='#CCCCCC' />
        <stop offset='1' stop-color='#999999' />
      </linearGradient>
      <radialGradient
        id='paint4_radial_12013_26018'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(42.8467 67.4311) rotate(106.939) scale(31.6981 19.009)'
      >
        <stop offset='0.58' stop-color='#EEEEEE' />
        <stop offset='1' stop-color='#CCCCCC' />
      </radialGradient>
      <linearGradient
        id='paint5_linear_12013_26018'
        x1='48.676'
        y1='93.2273'
        x2='62.1628'
        y2='49.2763'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#999999' />
        <stop offset='0.49' stop-color='#999999' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_12013_26018'
        x1='67.5475'
        y1='74.9929'
        x2='6.1332'
        y2='60.5008'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#B7B7B7' />
        <stop offset='1' stop-color='white' stop-opacity='0' />
      </linearGradient>
      <clipPath id='clip0_12013_26018'>
        <rect width='140' height='140' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
